const { cloneDeep, merge } = require('lodash');

function requireSettingGroups() {
    const context = require.context('./groups', true, /\.js$/);

    return context.keys().map(k => context(k));
}

const settingDefaults = Object.freeze(merge({}, ...requireSettingGroups()));
const settings = cloneDeep(settingDefaults);

module.exports = {
    settings,
    settingDefaults,
};



// WEBPACK FOOTER //
// ./src/common/settings/settings.constants.js